import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card, Button, Image } from "react-bootstrap";
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaCamera, FaEnvelope, FaPhoneAlt, FaBuilding, FaHome } from "react-icons/fa";

export default function Profile() {

    const [user, setUser] = useState(null);
    const [coverImage, setCoverImage] = useState(null);
    const [profileImage, setProfileImage] = useState(null);

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem("user"));
        if (stored?.data) {
            setUser(stored.data);
        }
    }, []);

    const handleCoverUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setCoverImage(URL.createObjectURL(file));
        }
    };

    const handleProfileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(URL.createObjectURL(file));
        }
    };

    if (!user) return null;

    return (
        <>
            <Container fluid style={{ background: "#f4f6fb", padding: "20px" }}>

                <div
                    style={{
                        background: "rgba(229, 219, 219, 0.35)",
                        borderRadius: "12px",
                        padding: "12px 20px",
                    }}
                    className="my-4"
                >
                    <Row className="align-items-center">


                        <Col xs={12} md={6} className="mb-2 mb-md-0">
                            <h6
                                style={{
                                    margin: 0,
                                    fontWeight: "600",
                                    color: "#333"
                                }}
                            >
                                User Profile
                                
                            </h6>
                        </Col>


                        <Col
                            xs={12}
                            md={6}
                            className="text-md-end d-flex justify-content-md-end justify-content-center align-items-center gap-3"
                        >
                           

                            <button
                               className="submit-btn"
                            >
                                <FaHome size={15} style={{ color: "#f4c430" }} /> Home
                            </button>
                        </Col>

                    </Row>
                </div>



                <Card
                    className="border-0 shadow-sm"
                    style={{
                        borderRadius: "15px",
                        overflow: "hidden",
                        transition: "0.3s"
                    }}
                    onMouseEnter={(e) =>
                    (e.currentTarget.style.boxShadow =
                        "0 15px 35px rgba(45,12,87,0.25)")
                    }
                    onMouseLeave={(e) =>
                    (e.currentTarget.style.boxShadow =
                        "0 5px 15px rgba(0,0,0,0.1)")
                    }
                >


                    <div
                        style={{
                            height: "220px",
                            background: coverImage
                                ? `url(${coverImage}) center/cover no-repeat`
                                : "linear-gradient(135deg,#2d0c57,#3c1361)",
                            position: "relative"
                        }}
                    >
                        <label
                            style={{
                                position: "absolute",
                                top: "15px",
                                right: "15px",
                                background: "#fff",
                                padding: "6px 12px",
                                borderRadius: "20px",
                                cursor: "pointer",
                                fontSize: "13px"
                            }}
                        >
                            <FaCamera className="me-1" />
                            Upload Cover
                            <input type="file" hidden onChange={handleCoverUpload} />
                        </label>
                    </div>


                    <Card.Body style={{ marginTop: "-60px" }}>
                        <Row className="align-items-center">


                            <Col md={3} className="text-center mb-3 mb-md-0">
                                <div className="d-flex justify-content-around">
                                    <div>
                                        <h6 className="fw-bold mb-0">938</h6>
                                        <small className="text-muted">Hotels</small>
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-0">3,586</h6>
                                        <small className="text-muted">Booking</small>
                                    </div>
                                    <div>
                                        <h6 className="fw-bold mb-0">2,659</h6>
                                        <small className="text-muted">Active Hotels</small>
                                    </div>
                                </div>
                            </Col>


                            <Col md={6} className="text-center">
                                <div style={{ position: "relative", display: "inline-block" }}>
                                    <Image
                                        src={
                                            profileImage
                                                ? profileImage
                                                : `https://ui-avatars.com/api/?name=${user?.name}&background=2d0c57&color=fff`
                                        }
                                        roundedCircle
                                        style={{
                                            width: "110px",
                                            height: "110px",
                                            border: "4px solid white",
                                            objectFit: "cover",
                                            transition: "0.3s"
                                        }}
                                        onMouseEnter={(e) =>
                                            (e.currentTarget.style.transform = "scale(1.08)")
                                        }
                                        onMouseLeave={(e) =>
                                            (e.currentTarget.style.transform = "scale(1)")
                                        }
                                    />

                                    <label
                                        style={{
                                            position: "absolute",
                                            bottom: "0",
                                            right: "0",
                                            background: "#2d0c57",
                                            color: "#fff",
                                            width: "32px",
                                            height: "32px",
                                            borderRadius: "50%",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            cursor: "pointer",
                                            boxShadow: "0 4px 10px rgba(0,0,0,0.2)"
                                        }}
                                    >
                                        <FaCamera size={12} />
                                        <input type="file" hidden onChange={handleProfileUpload} />
                                    </label>
                                </div>

                                <h5 className="fw-bold mt-3 mb-0">{user?.name}</h5>
                                <small className="text-muted">{user?.role}</small>
                            </Col>


                            <Col md={3} className="text-center text-md-end mt-3 mt-md-0">
                                <div className="mb-2">
                                    <FaFacebookF className="me-2 text-primary" />
                                    <FaTwitter className="me-2 text-info" />
                                    <FaInstagram className="me-2 text-danger" />
                                    <FaYoutube className="text-danger" />
                                </div>

                                {/* <Button
                                style={{
                                    background: "#2d0c57",
                                    border: "none",
                                    borderRadius: "20px",
                                    padding: "6px 18px"
                                }}
                            >
                                Add to Story
                            </Button> */}
                            </Col>

                        </Row>
                    </Card.Body>
                </Card>


                <Row className="mt-4 g-4">


                    <Col md={4}>
                        <Card
                            className="border-0 shadow-sm h-100"
                            style={{ borderRadius: "12px", transition: "0.3s" }}
                            onMouseEnter={(e) =>
                            (e.currentTarget.style.boxShadow =
                                "0 15px 30px rgba(45,12,87,0.2)")
                            }
                            onMouseLeave={(e) =>
                            (e.currentTarget.style.boxShadow =
                                "0 5px 15px rgba(0,0,0,0.1)")
                            }
                        >
                            <Card.Body>
                                <h6 className="fw-bold mb-3">Introduction</h6>

                                <p className="text-muted small">
                                    Travel Admin at {user?.organization?.name}
                                </p>

                                <p><FaEnvelope className="me-2" /> {user?.email}</p>
                                <p><FaPhoneAlt className="me-2" /> {user?.mobileNumber}</p>
                                <p><FaBuilding className="me-2" /> {user?.organization?.name}</p>
                            </Card.Body>
                        </Card>
                    </Col>


                    <Col md={8}>
                        <Card
                            className="border-0 shadow-sm"
                            style={{ borderRadius: "12px" }}
                        >
                            <Card.Body>
                                <input
                                    placeholder="Share your thoughts..."
                                    className="form-control mb-3"
                                />
                                <Button
                                    style={{
                                        background: "linear-gradient(135deg,#2d0c57,#3c1361)",
                                        border: "none"
                                    }}
                                >
                                    Post
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>

                </Row>
            </Container>
        </>
    );
}